module.exports = __webpack_public_path__ + "static/media/CodeWhite.d3537ecd.svg";